
import Loading from 'vux/src/components/loading/index.vue'

import CustomerService from './components/CustomerService/CustomerService'
import Locales from './views/Locales/Locales'

import { mapState } from 'vuex'
import {addClass, removeClass} from './utils/dom'

export default {
components: { Loading, CustomerService, Locales },
computed: {
...mapState({
loadingTxt: state => state.vux.loading.loadingTxt,
isLoading: state => state.vux.loading.visible,
route: state => state.route,
localePopVisible: state => state.app.localePopVisible,
locale: state => state.i18n.locale,
theme: state => state.app.theme
})
},
watch: {
locale () {
this.$store.dispatch('getSysConfigDict')
},
theme (val, oldVal) {
const htmlNode = document.documentElement
removeClass(htmlNode, oldVal)
addClass(htmlNode, val)
}
},
methods: {
},
beforeCreate () {
this.$store.dispatch('initThemeMode')
},
beforeDestroy () {
}
}



// WEBPACK FOOTER //
// ./src/App.vue